__turbopack_context__.v({
  "container": "whatYouBringSection-module-scss-module__Unu09G__container",
  "content": "whatYouBringSection-module-scss-module__Unu09G__content",
  "heading": "whatYouBringSection-module-scss-module__Unu09G__heading",
  "language": "whatYouBringSection-module-scss-module__Unu09G__language",
  "list": "whatYouBringSection-module-scss-module__Unu09G__list",
  "separator": "whatYouBringSection-module-scss-module__Unu09G__separator",
});
